import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["structureSelect", "commissionWrapper"]

  connect() {
    this.toggleCommission()
  }

  toggleCommission() {
    const value = this.structureSelectTarget.value
    if (value === "commission") {
      this.commissionWrapperTarget.classList.remove("d-none")
    } else {
      this.commissionWrapperTarget.classList.add("d-none")
    }
  }
}
